import localforage from 'localforage';

export interface IAvenyLocalStorage {
  getItem: <T>(key: string) => Promise<T | null>;
  setItem: <T>(key: string, value: T) => Promise<T>;
}

const avenyLocalStorage: IAvenyLocalStorage = {
  getItem: localforage.getItem,
  setItem: localforage.setItem,
};

export default avenyLocalStorage;
